import React, { useMemo, useCallback } from 'react';
import DropDown from '../dropdown';
import { Packages } from '../../../api/services/next';

const PackagesDropDown = ({spec: externalSpec, includeRoomOnly, ...rest}) => {
    // Restores the pre-refactor behavior: a caller-supplied spec is used as-is (no
    // IsActive filter forced onto it) — only the "no spec at all" case defaults to
    // active-only. Previously `spec` wasn't destructured separately, so a caller's
    // `spec` prop fully replaced the internal `{IsActive: true}} default via JSX's
    // last-prop-wins spread order; merging IsActive:true onto every caller's spec
    // (regardless of whether they asked for it) silently hid inactive packages for
    // callers like RestrictionsPopup that never opted into the filter.
    const spec = useMemo(() => externalSpec ?? { IsActive: true }, [externalSpec])

    const injectRoomOnly = useCallback((items) => {
        const existingIndex = items.findIndex(p => p.Name?.toLowerCase() === 'room only');
        const name = existingIndex > -1 ? items[existingIndex].Name : 'ROOM ONLY';
        const filtered = existingIndex > -1 ? items.filter((_, i) => i !== existingIndex) : items;
        return [{
            Id: -1,
            HotelChainId: -1,
            Name: name,
            IsActive: true,
            PackageElements: []
        }, ...filtered];
    }, []);

    return <DropDown
        api={Packages.GetPackages}
        spec={spec}
        textField="Name"
        valueField="Id"
        sort={includeRoomOnly ? injectRoomOnly : undefined}
        {...rest}
    />
}

export default PackagesDropDown

